import type { Post } from "@/types";
import React, { FC } from "react";
import { Image } from "../image";
import { AnimatePresence, motion } from "framer-motion";

export const PostHero: FC<Post> = (post) => {
  const formatDate = (date: string) => {
    const dateObj = new Date(date);
    const month = dateObj.toLocaleString("default", { month: "long" });
    const day = dateObj.getDate();
    return `${month} ${day}`;
  };

  // === Toggle logic (backwards-compatible) ==============================
  // Default to showing the hero image for all existing posts:
  let showHero = true;

  // If you added a "showHeroImage" boolean field in Contentful,
  // respect it when explicitly set:
  if (Object.prototype.hasOwnProperty.call(post as any, "showHeroImage")) {
    const v = (post as any).showHeroImage;
    if (typeof v === "boolean") showHero = v;
  }

  // If instead you added a "hideHeroImage" field, this inverts it:
  if (Object.prototype.hasOwnProperty.call(post as any, "hideHeroImage")) {
    const v = (post as any).hideHeroImage;
    if (typeof v === "boolean") showHero = !v;
  }
  // ======================================================================

  return (
    <AnimatePresence>
      <section className="postHero">
        <div className="wrapper">
          <motion.div
            className="postHero--info"
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
          >
            <div className="postHero--date">{formatDate(post.date)}</div>
            <div className="postHero--label">{post.label}</div>
          </motion.div>

          <motion.h1
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
            transition={{ delay: 0.1 }}
            className="postHero--title"
          >
            {post.title}
          </motion.h1>
        </div>

        {/* Only render the large hero image if allowed and available */}
        {showHero && post.coverImage && (
          <motion.div
            className="wrapper wrapper_lg"
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 1.1, opacity: 0 }}
            transition={{
              duration: 0.9,
              delay: 0.2,
              ease: [0.17, 0.55, 0.55, 1],
            }}
          >
            <Image
              src={post.coverImage}
              alt={post.title}
              className="postHero--image"
            />
          </motion.div>
        )}
      </section>
    </AnimatePresence>
  );
};
